import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { PaymentTypes } from '@grandvisionhq/api-client';
import { MediaQuery, Card } from '@grandvisionhq/common';
import { Heading } from '@grandvisionhq/elements';
import { getPaymentImplementation } from '@grandvisionhq/payments';
import { PaymentInfo } from '../modules/PaymentInfo/PaymentInfo.js';
import { getGraphQLPaymentProviderName } from '../StepPayment/utils/get-payment-provider-name.js';
import { getGraphQLPaymentMethodName } from '../StepPayment/utils/get-payment-method-name.js';
import { getShippingMethodInfo } from '../utils/get-shipping-method-info.js';
import { OrderCallToActionContainer } from '../modules/OrderCallToAction/containers/OrderCallToActionContainer.js';
import { isPickupStore, isPickupPoint } from '../utils/shipping-method.js';
import { LocationInfo } from '../modules/LocationInfo/layout/LocationInfo.js';
import { optionalFormContainsData } from '../utils/optional-form-contains-data.js';
import { ServiceStoreSummary } from '../modules/ServiceStore/layout/ServiceStoreSummary.js';
import { useCheckoutSettings } from '../context/CheckoutSettings/context.js';

const productMessageKeys = [
    'cartContainsContactLenses',
    'cartContainsPrescriptionGlasses',
    'cartContainsSolutions',
    'cartContainsSunglasses',
    'cartContainsSubscription', 
];
var OrderConfirm = (_param)=>{
    var { summaries , selectedPaymentDetails , selectedStore , serviceStore , selectedPickupPoint , invoice , order , callbackResultCode , shippingMethodsAsides , labels  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "summaries",
        "selectedPaymentDetails",
        "selectedStore",
        "serviceStore",
        "selectedPickupPoint",
        "invoice",
        "order",
        "callbackResultCode",
        "shippingMethodsAsides",
        "labels"
    ]);
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8;
    const { company: CompanySummary , addresses: Addresses , contactDetails: ContactDetailsSummary , invoice: InvoiceSummary ,  } = summaries;
    const paymentProvider = ((ref1 = order === null || order === void 0 ? void 0 : (ref = order.paymentInfo) === null || ref === void 0 ? void 0 : ref.payments[0]) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.obj) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.paymentMethodInfo) === null || ref3 === void 0 ? void 0 : ref3.paymentInterface) || undefined;
    const paymentType = ((ref5 = order === null || order === void 0 ? void 0 : (ref4 = order.paymentInfo) === null || ref4 === void 0 ? void 0 : ref4.payments[0]) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.obj) === null || ref6 === void 0 ? void 0 : ref6.paymentMethodInfo.method) || undefined;
    const selectedPaymentMethod = {
        provider: getGraphQLPaymentProviderName(paymentProvider),
        type: getGraphQLPaymentMethodName(paymentType)
    };
    const { features  } = useCheckoutSettings();
    const paymentImplementation = selectedPaymentMethod && getPaymentImplementation(selectedPaymentMethod.provider, selectedPaymentMethod.type);
    const paymentInfo = {
        selectedPaymentDetails,
        selectedPaymentMethod,
        totalPrice: order === null || order === void 0 ? void 0 : order.totalPrice,
        summary: paymentImplementation === null || paymentImplementation === void 0 ? void 0 : paymentImplementation.summary
    };
    const orderNumber = order === null || order === void 0 ? void 0 : order.orderNumber;
    const shippingMethod = order === null || order === void 0 ? void 0 : (ref7 = order.shippingInfo) === null || ref7 === void 0 ? void 0 : ref7.shippingMethodName;
    const shippingMethodInfo = getShippingMethodInfo(labels.summary, shippingMethod, shippingMethodsAsides);
    const isBigScreen = MediaQuery.useIsAbove(MediaQuery.BreakpointName.TABLET_PORTRAIT);
    return /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step checkout-step--completed"
    }, /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step__heading"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "small",
        component: "h1"
    }, labels.title), /*#__PURE__*/ React.createElement("p", null, callbackResultCode && callbackResultCode.toLowerCase() !== PaymentTypes.CallbackResultCode.Authorised ? labels.callbackResult[callbackResultCode] : labels.completed, orderNumber && /*#__PURE__*/ React.createElement("strong", null, " ", orderNumber)), labels.additionalMessage && /*#__PURE__*/ React.createElement("p", null, labels.additionalMessage), productMessageKeys.map((key)=>{
        const selectorResult = rest[key];
        return selectorResult === true && /*#__PURE__*/ React.createElement("p", {
            key: key,
            className: "checkout-step__product-specific-message"
        }, /*#__PURE__*/ React.createElement("strong", null, labels[key]));
    })), order ? /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step__order"
    }, isBigScreen && /*#__PURE__*/ React.createElement(OrderCallToActionContainer, null), /*#__PURE__*/ React.createElement("div", {
        className: "checkout-step__order-details card--colapse-borders"
    }, /*#__PURE__*/ React.createElement(Heading, {
        variant: "smallest",
        component: "h2"
    }, labels.yourDetails), /*#__PURE__*/ React.createElement(PaymentInfo, swcHelpers.extends({}, paymentInfo)), ContactDetailsSummary, /*#__PURE__*/ React.createElement(Card, null, /*#__PURE__*/ React.createElement(Card.Content, null, /*#__PURE__*/ React.createElement(Card.Text, {
        variant: "body-head"
    }, labels.shipmentDetailsTitle), /*#__PURE__*/ React.createElement(Card.Text, null, shippingMethodInfo.label, " ", shippingMethodInfo.aside && shippingMethodInfo.aside))), isPickupStore(shippingMethod) && selectedStore && /*#__PURE__*/ React.createElement(LocationInfo, {
        location: selectedStore
    }), isPickupPoint(shippingMethod) && selectedPickupPoint && /*#__PURE__*/ React.createElement(LocationInfo, {
        location: selectedPickupPoint
    }), Addresses, invoice && optionalFormContainsData(invoice) && /*#__PURE__*/ React.createElement(React.Fragment, null, InvoiceSummary), ((ref8 = order.billingAddress) === null || ref8 === void 0 ? void 0 : ref8.company) && /*#__PURE__*/ React.createElement(React.Fragment, null, CompanySummary), (features === null || features === void 0 ? void 0 : features.isServiceStoreEnabled) && serviceStore && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(ServiceStoreSummary, null)))) : null, /*#__PURE__*/ React.createElement(OrderCallToActionContainer, null));
};

export { OrderConfirm };
//# sourceMappingURL=OrderConfirm.js.map
